import { ToggleButtonTogether } from 'react-together-primereact'

export function PrimeReactToggleButtonTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <ToggleButtonTogether rtKey='toggle-button-doc-demo' />
    </div>
  )
}
